function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Delivery = function Delivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    fillRule: "evenodd",
    d: "M22.69 10.87a.72.72 0 0 0-.17-.58L19.4 6.58a.74.74 0 0 0-.57-.27h-1.92l.16-1.39a.756.756 0 0 0-.75-.84H4.33c-.41 0-.75.34-.75.75s.34.75.75.75h11.16l-.9 7.78v.08a.3.3 0 0 0 .018.08l.012.04c0 .04.01.09.03.13.015.043.04.082.064.119l.026.041.02.035q.014.026.03.045s.01 0 .02.01c.05.05.11.09.18.13a.2.2 0 0 1 .035.024l.035.026q.135.06.3.06h5.39l-.43 3.19h-1.15a2.77 2.77 0 0 0-2.67-2.03c-1.28 0-2.34.86-2.67 2.03h-4.1a2.77 2.77 0 0 0-2.67-2.03c-1.28 0-2.34.86-2.67 2.03H2.81c-.41 0-.75.34-.75.75s.34.75.75.75h1.58a2.77 2.77 0 0 0 2.67 2.03c1.28 0 2.34-.86 2.67-2.03h4.1a2.77 2.77 0 0 0 2.67 2.03c1.28 0 2.34-.86 2.67-2.03h1.81c.38 0 .69-.28.74-.65l.64-4.69.36-2.68zM7.03 19.42c-.71 0-1.28-.58-1.28-1.28s.58-1.28 1.28-1.28 1.28.58 1.28 1.28-.58 1.28-1.28 1.28m9.44 0c-.71 0-1.28-.58-1.28-1.28s.58-1.28 1.28-1.28 1.28.58 1.28 1.28-.58 1.28-1.28 1.28m.27-11.62-.569 4.88h4.76l.23-1.7-2.68-3.18zM9.01 8.81c0-.41-.34-.75-.75-.75h-6.5c-.41 0-.75.34-.75.75s.34.75.75.75h6.5c.41 0 .75-.34.75-.75m-2.75 4.38h-3.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.5c.41 0 .75.34.75.75s-.34.75-.75.75",
    clipRule: "evenodd"
  }));
};
export default Delivery;
Delivery.displayName = 'Delivery';